import {
    PictureListItemData,
    PictureListTypeData,
    classNames,
    formatMultilineText,
} from "@plinknz/tah-website-elements";
import * as React from "react";
import { useVisible } from "react-visible-image";
import { generate } from "shortid";
import { hexToRgb, inverseRgb, rgbToString } from "../../utility/colours";

export interface PictureListProps {
    data: PictureListTypeData;
}

interface Styles {
    background: {background?: string};
    title: {color?: string};
    text: {color?: string};
}

const PictureListItem = ({
    title,
    picture,
    subtitle,
    description,
    background_colour,
}: PictureListItemData) => {
    const item = React.useRef<HTMLDivElement>(null);
    const isVisible = useVisible(item);
    const profileClass = classNames("profile");
    const style:Styles = {
        background: background_colour ? {background: background_colour} : {},
        title: {},
        text: {},
    };
    
    if (background_colour) {
        const rgb = hexToRgb(background_colour);
        style.title.color = rgbToString(inverseRgb({rgb}));
        style.text.color = rgbToString(inverseRgb({rgb, emphasise: true}));
    }

    return (
        <div className={profileClass} ref={item} key={generate()}>
            <h2 className="profile-content-title">{title}</h2>
            <div className="profile-columns">
                <div
                    className="profile-image right bottom"
                    style={{
                        backgroundImage: isVisible
                            ? `url('${picture?.url}')`
                            : "",
                    }}
                />
                <div className="profile-columns">
                    <div className="profile-columns-text" style={style.background}>
                        {subtitle && (
                            <h2 className="profile-subtitle" style={style.title}>{subtitle}</h2>
                        )}
                        {description && (
                            <div style={style.text}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: formatMultilineText(description),
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const PictureList = ({ data }: PictureListProps) => {
    return (
        <div
            className="profile-wrapper || constrain-width"
            data-testid="profile">
            <h3>{data.profileHeading}</h3>
            <div>{data?.profiles.map(PictureListItem)}</div>
        </div>
    );
};
